import { render, staticRenderFns } from "./AgingaccountspayReportDetail.vue?vue&type=template&id=2ef06b03"
import script from "./AgingaccountspayReportDetail.vue?vue&type=script&lang=js"
export * from "./AgingaccountspayReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports